function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2016 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
import { AuthConstant } from '../../../constants/auth.constant'; //// CONTROLLER ////

export var RequestCCDialogController =
/*#__PURE__*/
function () {
  _createClass(RequestCCDialogController, null, [{
    key: "$inject",
    get: function get() {
      return ['$mdDialog', '$scope', '$window', 'EndPointService', 'NotificationService', 'SpotResourceFactory', 'spotId', 'emailAddress', 'firstName', 'lastName'];
    }
  }]);

  function RequestCCDialogController($mdDialog, $scope, $window, EndPointService, NotificationService, SpotResourceFactory, spotId, emailAddress, firstName, lastName) {
    _classCallCheck(this, RequestCCDialogController);

    /* BINDABLE: INJECTS */
    Object.assign(this, {
      $mdDialog: $mdDialog,
      $scope: $scope,
      $window: $window,
      EndPointService: EndPointService,
      NotificationService: NotificationService,
      SpotResourceFactory: SpotResourceFactory,
      spotId: spotId,
      emailAddress: emailAddress,
      firstName: firstName,
      lastName: lastName
    });
    this.authConstants = new AuthConstant();
    var vm = this;
    /* BINDABLE: DATA */

    vm.options = {
      captionRequested: true,
      haveScript: false,
      approvalFile: false,
      approvalEmails: vm.emailAddress,
      sidecarFile: false,
      notes: '',
      firstName: vm.firstName,
      lastName: vm.lastName
    };
    vm.filesToUpload = [];
    vm.fileErrors = [];
    vm.uploader = null;
    /* EVENTS */
  }

  _createClass(RequestCCDialogController, [{
    key: "submit",
    value: function submit() {
      var vm = this;
      vm.submitting = true;
      vm.uploader = new Flow({
        target: vm.EndPointService.uploadCCAssetEndpoint,
        headers: function headers() {
          var accountHash = JSON.parse(vm.$window.localStorage[vm.authConstants.session.ACCOUNT_HASH]);
          var sessionData = JSON.parse(vm.$window.sessionStorage[vm.authConstants.session.SESSION_DATA]);
          return {
            Authorization: 'Bearer ' + accountHash[sessionData.accountId]
          };
        },
        testMethod: false,
        // singleFile: true,
        fileParameterName: 'file',
        uploadMethod: 'POST',
        withCredentials: true,
        allowDuplicateUploads: true,
        // 5Mb chunks, should force everything to go at once, since it's limited to that max size
        chunkSize: 5 * 1024 * 1024,
        simultaneousUploads: 3,
        query: {
          ignoreLoadingBar: true,
          waitForAutoConversions: false
        },
        testChunks: false
      });

      if (vm.options.haveScript === false) {
        vm.filesToUpload = [];
      }

      for (var upload in vm.filesToUpload) {
        if (!vm.filesToUpload.hasOwnProperty(upload)) {
          // Skip this upload if it's some inherited property
          break;
        } // Add the spot file to the uploader


        vm.uploader.addFile(vm.filesToUpload[upload]);
      }

      var newAssetIds = [];
      vm.uploader.upload();
      vm.uploader.on('fileSuccess', function (file, message, chunk) {
        newAssetIds.push({
          filename: file.name,
          id: message
        });
      });
      vm.uploader.on('complete', function () {
        // Make the call to submit to Prod Services
        // use newAssetIds to populate the request to send an email
        vm.options.scripts = newAssetIds;
        vm.options.accountName = JSON.parse(vm.$window.sessionStorage[vm.authConstants.session.SESSION_DATA]).accountName;
        vm.options.approvalEmails = vm.options.approvalFile ? vm.options.approvalEmails : null;
        vm.SpotResourceFactory.sendForCC({
          id: vm.spotId
        }, vm.options).subscribe(function () {
          // NotificationService toast should be displayed
          vm.NotificationService.showNotificationToast('Spot submitted for Closed Captioning');
          vm.$mdDialog.hide(true);
        }, function (err) {
          // NotificationService error should be displayed
          vm.NotificationService.showNotificationToast('Spot failed to submit for Closed Captioning', err);
          vm.$mdDialog.hide(false);
        });
      });
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var vm = this;
      vm.$mdDialog.cancel();
    }
  }, {
    key: "removeScript",
    value: function removeScript(index) {
      var vm = this;
      vm.filesToUpload.splice(index, 1);
    }
  }, {
    key: "$onInit",
    value: function $onInit() {// Do things on initialization
    }
  }]);

  return RequestCCDialogController;
}();